<template>
    <div>
        <div v-for="data in data_tci" class="container my-4">        
            <div class=" container cash-win mt-5">
                <div class="row boxBanner">
                    <div class="col-12 col-lg-6 col-md-6 d-flex align-items-center flex-column my-auto">
                        <h4 class="my-3 p-3 text-break">{{ data.title }}</h4>
                        <div class="row d-flex align-items-center justify-content-center tableCash w-100">                        
                            <div v-if="data.text_box_1" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_1 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_2" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_2 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_3" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_3 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_4" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_4 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_5" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_5 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_6" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_6 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_7" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_7 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_8" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_8 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_9" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_9 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_10" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_10 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_11" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_11 }}</p>
                                </div>
                            </div>
                            <div v-if="data.text_box_12" class="col-6">
                                <div class="cashTotal">
                                    <p class="text-break">{{ data.text_box_12 }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-md-6 imgBanner">
                        <div class="imgBox">                     
                            <img :src="url_media + data.image" alt="img_banner">
                        </div>                
                    </div>
     
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            identification: {
                default: null,
            },
            url_media:{
                default: '',
            },
        },
        data() {
            return {
                data_tci: [],
            };
        },
        mounted() {
            this.getCurrentData();
        },
        methods: {
            getCurrentData() {
                axios.get(`/get-tci-data?identification=${this.identification}`)
                    .then(({ data }) => {
                        this.data_tci = data.data_tci;
                    });
            },
        }
    }
</script>
